
import { SET_HOVERED_TIME } from "../actions/timeActions";

const initialState = {
  hoveredTime: null,
};

const timeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HOVERED_TIME:
      return {
        ...state,
        hoveredTime: action.payload,
      };
    default:
      return state;
  }
};

export default timeReducer;
